// 全站静态内容数据：黑料考古 / 旧料盘点资讯聚合站
// 说明：条目均以「旧料整理、信源待核」的媒体考古口吻呈现，供整站静态展示。

export type FeedItem = {
  id: string;
  kind: string;
  title: string;
  summary: string;
  meta: string;
  year: string;
};

export const focusItems: FeedItem[] = [
  {
    id: "focus-01",
    kind: "焦点旧料",
    title: "一份被反复下架的 2014 年「早年黑历史」帖，为何至今仍在被扒",
    summary:
      "从早期论坛盖楼到评论区翻尸，帖子在十年间被删又被补档。我们按存证时间线把每次下架与二次传播的节点逐一归档，还原这段历史遗留的完整路径。",
    meta: "考据 · 存证补档 · 阅读 8 分钟",
    year: "2014",
  },
  {
    id: "focus-02",
    kind: "翻旧账",
    title: "「互联网没有记忆」是句反话：那些被翻出来的五年前旧账",
    summary:
      "网友翻旧账并不只看结论，而是顺着当年的时间戳、截图与转发链逐条比对。盘点三件近期因翻旧账重新进入公共讨论的早年事件。",
    meta: "舆情观察 · 评论区考古 · 阅读 6 分钟",
    year: "2021",
  },
  {
    id: "focus-03",
    kind: "历史遗留",
    title: "被遗忘服务器的最后一份备份：藏在个人站的年代档案",
    summary:
      "大量早年黑料随个人站与论坛一起停止维护，偶尔以老备份的形式重见天日。这类「历史遗留」多为无主存档，整理时需格外核对信源。",
    meta: "数字考古 · 存档检索 · 阅读 5 分钟",
    year: "2010",
  },
];

export const categoryGroups: {
  key: string;
  name: string;
  desc: string;
  items: FeedItem[];
}[] = [
  {
    key: "dug",
    name: "被扒档案",
    desc: "从线索到坐实的完整扒文轨迹，按时间与来源分层记录。",
    items: [
      {
        id: "dug-1",
        kind: "被扒",
        title: "一条留言引出的小号链，旧博文被逐条比对后翻出当年记录",
        summary: "开帖者仅凭一张糊图起疑，围观者顺藤摸瓜，最终拼出完整时间线。",
        meta: "扒文还原 · 2024 重新整理",
        year: "2019",
      },
      {
        id: "dug-2",
        kind: "被扒",
        title: "获奖通稿与现场视频的日期差，成为被扒的关键破绽",
        summary: "同一场活动的两种官方口径前后矛盾，索引原始链接后问题集中指向早期通稿。",
        meta: "信源比对 · 存证可查",
        year: "2017",
      },
    ],
  },
  {
    key: "old-account",
    name: "翻旧账",
    desc: "旧账翻起时的传播链条、参与度曲线与后续回应一并收录。",
    items: [
      {
        id: "old-1",
        kind: "翻旧账",
        title: "几年前的一句旧发言，这次被完整截图重新顶到首页",
        summary: "翻旧账的启动往往由一段旧采访切片开始，再经评论区二次加工扩散。",
        meta: "切片流传 · 传播复盘",
        year: "2022",
      },
      {
        id: "old-2",
        kind: "翻旧账",
        title: "旧账翻清之后：当事人两年内的回应变化归档",
        summary: "从回避、声明到限流删除，各阶段的公开回应均被按节点收录。",
        meta: "回应时间轴 · 持续更新",
        year: "2023",
      },
    ],
  },
  {
    key: "youth",
    name: "早年黑历史",
    desc: "成名前那些零散发言与经历，跨站点归拢成一条早年档案。",
    items: [
      {
        id: "youth-1",
        kind: "早年",
        title: "走红前的公开提问与点赞记录，被逐条汇总成早年侧写",
        summary: "不算实锤，却还原了更真实的早年状态，评论区据此分成两派。",
        meta: "早年侧写 · 仅供讨论",
        year: "2013",
      },
      {
        id: "youth-2",
        kind: "早年",
        title: "被删除的旧动态虽已不在，第三方存档里仍留有小号痕迹",
        summary: "删帖前后快照对比，说明早年黑历史在网络留下的持久指纹。",
        meta: "快照存档 · 索引编号",
        year: "2011",
      },
    ],
  },
  {
    key: "legacy",
    name: "历史遗留",
    desc: "停更的站点、失效的域名与无人认领的旧帖，属最难考据的一类。",
    items: [
      {
        id: "legacy-1",
        kind: "遗留",
        title: "停更三年的老专题页，仍藏着未被公开索引的早年记录",
        summary: "无主页外链、无搜索引擎收录，属典型的「你没见过的隐藏历史黑料」。",
        meta: "深网检索 · 专题归档",
        year: "2016",
      },
      {
        id: "legacy-2",
        kind: "遗留",
        title: "失效域名下的最后缓存，把一段历史遗留重新带回可见区",
        summary: "通过镜像与缓存还原的页面，成为追溯这段旧事的重要旁证。",
        meta: "缓存还原 · 待核",
        year: "2018",
      },
    ],
  },
];

export const timelineEra: {
  era: string;
  tag: string;
  text: string;
}[] = [
  {
    era: "2006–2010",
    tag: "BBS 时代",
    text: "大量早年黑历史诞生于论坛盖楼，证据以文字与链接为主，留存度最脆弱。",
  },
  {
    era: "2011–2015",
    tag: "微博爆发期",
    text: "碎片化截图开始成为主证据形态，删帖快照也从这个阶段集中出现。",
  },
  {
    era: "2016–2019",
    tag: "视频与长文期",
    text: "视频切片、直播回放加入考据，历史遗留的形态转向多介质并存。",
  },
  {
    era: "2020–至今",
    tag: "考古补档期",
    text: "越来越多早期内容被集中归档整理，全网黑料考古进入系统化阶段。",
  },
];

export const deepDives: {
  id: string;
  tag: string;
  title: string;
  summary: string;
  read: string;
}[] = [
  {
    id: "dd-1",
    tag: "年度盘点",
    title: "年度翻旧账事件 Top 榜：这轮旧账从何而起",
    summary: "按讨论量、存续时长与后续影响三重维度，排出今年最受关注的翻旧账事件并逐一起因拆解。",
    read: "盘点列表 · 12 项",
  },
  {
    id: "dd-2",
    tag: "考据方法",
    title: "如何为一段早年黑历史做时间戳存证",
    summary: "从原文截图、第三方存档到站内检索，梳理一套可复用的旧料存证与复核步骤。",
    read: "方法指南 · 图文并茂",
  },
  {
    id: "dd-3",
    tag: "争议观察",
    title: "「被扒」与「误伤」之间：那些最后被证伪的旧料",
    summary: "不是每段黑料都经得起考据，盘点数起曾刷屏后被证伪或反转的典型旧账案例。",
    read: "案例复盘 · 谨慎阅读",
  },
  {
    id: "dd-4",
    tag: "分类导览",
    title: "历史遗留旧料的五大来源：论坛、个人站、帖吧、旧稿与缓存",
    summary: "对「隐藏的历史黑料」作系统梳理，标注每类来源的可靠度与检索难度。",
    read: "来源导览 · 地图式",
  },
  {
    id: "dd-5",
    tag: "媒体观察",
    title: "早期黑历史为何总在特定节点被重新挖出",
    summary: "解读旧料回流背后的触发机制：档期、人设更新与评论区记忆的交互作用。",
    read: "趋势观察 · 深度",
  },
  {
    id: "dd-6",
    tag: "资料库",
    title: "全网黑料考古资料索引：持续收录的历史遗留清单",
    summary: "以表格索引的形式集中归档已核实与待核实的旧料条目，供对照与补充。",
    read: "资料索引 · 持续扩充",
  },
];

export const hotRank: FeedItem[] = [
  {
    id: "hot-1",
    kind: "热议",
    title: "旧综艺的某段剪影被重新标注，弹幕考古区隔夜刷屏",
    summary: "评论区逐帧放大讨论，最终指向一段被略过的早年片段。",
    meta: "弹幕考古",
    year: "2015",
  },
  {
    id: "hot-2",
    kind: "热议",
    title: "几年前旧采访的一句话，被翻出来后登上讨论热榜",
    summary: "翻旧账的传播通常以秒级截图开始，随后扩散到多平台。",
    meta: "翻旧账",
    year: "2020",
  },
  {
    id: "hot-3",
    kind: "热议",
    title: "停更博文意外被算法重新推流，旧评论区一夜复活",
    summary: "算法偶然把早年内容重新送进信息流，引发新一轮考古。",
    meta: "算法考古",
    year: "2018",
  },
  {
    id: "hot-4",
    kind: "热议",
    title: "网友晒出十年老截图，对比当下的反差被反复转发",
    summary: "新旧对照式内容最易引发集体回忆与继续深挖。",
    meta: "反差对照",
    year: "2012",
  },
  {
    id: "hot-5",
    kind: "热议",
    title: "一条失效外链背后的完整早年记录，被社区接力补全",
    summary: "多人接力补档使一段近乎湮灭的旧料重新变得可考。",
    meta: "接力补档",
    year: "2016",
  },
];

export const trustPoints: {
  icon: string;
  title: string;
  desc: string;
}[] = [
  {
    icon: "ri-time-line",
    title: "信源可回溯",
    desc: "每条旧料尽量附原始出处或存档索引，方便独立核对，不替读者下结论。",
  },
  {
    icon: "ri-focus-3-line",
    title: "存证优先",
    desc: "对截图与转述采取克制立场，标注“待核”与“已证伪”，避免误伤。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续补档",
    desc: "帖子被删、页面失效后会继续追索引并补回，让历史遗留不易彻底湮灭。",
  },
];

export const faqs: {
  q: string;
  a: string;
}[] = [
  {
    q: "这里的内容和普通娱乐号有什么不同？",
    a: "本站不做短平快的情绪化爆料，而是按“考据—分类—归档”的方式整理旧料：更重视出处、时间线与存续状态，倾向还原而非煽动。",
  },
  {
    q: "“历史遗留”和“早年黑历史”有什么区别？",
    a: "早年黑历史多指成名或关注度上升前留下的旧发言与旧经历；历史遗留则偏指停更站点、失效链接与无主存档这类考据难度更高的旧料。",
  },
  {
    q: "内容如何被判定为可信？",
    a: "我们会优先收录能回溯到原始截图或第三方存档的条目，并对无法验证的部分明确标注“待核”。证伪后的条目也会进入专题复盘，不会只报喜不报忧。",
  },
  {
    q: "为什么有些页面会跳转或消失？",
    a: "旧料常因原作者删除、站点停运而无法直接访问。我们会保留可索引的编号说明，并尽量以快照或缓存补档的方式维持可读。",
  },
  {
    q: "如何把一段你知道的旧料提供给本站？",
    a: "可以在页面上部“报料线索”入口提交来源链接与简要说明。提交仅作信息登记，不代表会被采用，也不接入任何账号系统。",
  },
];